@if (taxReturn) {
<div>
  <div class="client-popu-nav">
    <span
      class="client-name"
      [attr.data-test-ref]="'client-name'"
      [routerLink]="'/clients/' + client?.id"
      [queryParams]="{ taxYear: taxReturn?.year }"
      title="{{ client?.name }}"
      >{{ client?.name }}</span
    >
    <span class="separator"> &gt; </span>
    <span
      class="population-name"
      [attr.data-test-ref]="'client-name'"
      [routerLink]="[
        '/clients',
        client?.id,
        'populations',
        population?.id,
        uiConfig.config.taxpayerAliasPath
      ]"
      [queryParams]="{ taxYear: taxReturn?.year }"
      title="{{ population?.name }}"
      >{{ population?.name }}</span
    >
  </div>
  <h3 id="taxpayer-name">
    {{ taxReturn?.firstName }} {{ taxReturn?.lastName }}
  </h3>
  <h4>{{ uiConfig?.config?.atlasId }} {{ taxReturn?.atlasId }}</h4>
  <h6 *transloco="let t">
    {{ "last-calcs-run-date" | transloco }}
    {{ calcsLastRunDate ? calcsLastRunDate : t("has-not-run-yet") }}
  </h6>
  <div>
    <strong id="tax-financial-yr">{{ yearLabel }} {{ taxReturn?.year }}</strong>
    <br />
    @if (taxReturn?.fullStatus) {
    <div class="status">
      <app-status-badge
        [status]="taxReturn?.fullStatus"
        [complexity]="taxReturn?.statusComplexity"
      ></app-status-badge>
      <div class="questionnaire-type">
        {{ questionnaireTypeName }}
      </div>
      <div class="status-desc" [innerHTML]="taxReturnPhase"></div>
    </div>
    }
  </div>
  <div
    class="ui primary button tr-run-calc-btn"
    (click)="runCalcs()"
    [ngClass]="{
      loading: isRunningCalcs,
      disabled:
        isRunningCalcs || (isLodged() && disableRunCalcForLodgedTaxReturn)
    }"
  >
    RUN CALCS
  </div>
  @if (taxReturn) {
  <div id="menu" class="ui list hidden-scrollbar">
    @if (taxReturn?.categories | isGlobal: true?.length) {
    <div>
      <b>{{ "global-categories" | transloco }}</b>
      @for ( item of taxReturn?.categories | isGlobal: true ; track item) {
      <div
        [routerLink]="[uiConfig?.config?.taxReturnAliasPath, taxReturn?.id]"
        [queryParams]="{
          category: item?.name | lowercase | cleanElementSelector,
          isGlobal: true,
          snapshot: taxReturn.snapshotId
        }"
        class="item"
        [routerLinkActive]="['active']"
        id="cat{{ item.id }}"
      >
        <div class="category-name">{{ item.name }}</div>
        @if (getWarningsCount(item) > 0) {
        <div class="count">
          {{ getWarningsCount(item) }}
        </div>
        }
      </div>
      }
    </div>
    }
    <div class="divider"></div>
    @if (taxReturn?.categories | isGlobal: false?.length) {
    <div>
      <b>{{ "return-categories" | transloco }}</b>
      @for ( item of taxReturn?.categories | isGlobal: false ; track item) {
      <div
        [routerLink]="[uiConfig?.config?.taxReturnAliasPath, taxReturn?.id]"
        [queryParams]="{
          category: item?.name | lowercase | cleanElementSelector,
          isGlobal: false,
          snapshot: taxReturn.snapshotId
        }"
        class="item"
        [routerLinkActive]="['active']"
        id="cat{{ item.id }}"
      >
        <div class="category-name">{{ item.name }}</div>
        @if (getWarningsCount(item) > 0) {
        <div class="count">
          {{ getWarningsCount(item) }}
        </div>
        }
      </div>
      }
    </div>
    }
    <div class="divider"></div>
    @if ( isSmartFormsEnabled && (taxReturn?.categories | isGlobal:
    true?.length) ) {
    <div>
      <b>Smart Forms</b>
      @for (smartForm of smartFormTypes; track smartForm) {
      <div
        [routerLink]="[
          uiConfig?.config?.taxReturnAliasPath,
          taxReturn?.id,
          uiConfig?.config?.smartFormAliasPath,
          smartForm?.id
        ]"
        [queryParams]="{
          category: smartForm?.name | lowercase | cleanElementSelector,
          isGlobal: true,
          snapshot: taxReturn.snapshotId
        }"
        class="item"
        [routerLinkActive]="['active']"
        id="smartForm{{ smartForm.id }}"
      >
        <div class="category-name">{{ smartForm.name }}</div>
        <!-- <div *ngIf="getWarningsCount(item) > 0" class="count">{{getWarningsCount(item)}}</div> -->
      </div>
      }
    </div>
    }
    <div class="divider"></div>
    <div
      [routerLink]="getLinkUploadSource()"
      [routerLinkActive]="['active']"
      [queryParams]="{ taxYear: taxReturn?.year }"
      class="item"
    >
      {{ "upload-source" | transloco }}
    </div>
    <div
      [routerLink]="[
        uiConfig?.config?.taxReturnAliasPath,
        taxReturn?.id,
        'notes'
      ]"
      [routerLinkActive]="['active']"
      class="item"
    >
      {{ "notes" | transloco }}
    </div>
    <div
      [routerLink]="[
        uiConfig?.config?.taxReturnAliasPath,
        taxReturn?.id,
        'missing-information'
      ]"
      [routerLinkActive]="['active']"
      class="item"
    >
      {{ "missing-information" | transloco }}
    </div>
    <div
      [routerLink]="[
        uiConfig?.config?.taxReturnAliasPath,
        taxReturn?.id,
        'warnings'
      ]"
      [routerLinkActive]="['active']"
      class="item"
    >
      {{ "Warnings-Flags-Comments" | transloco }}
    </div>
    <div
      [routerLink]="[
        uiConfig?.config?.taxReturnAliasPath,
        taxReturn?.id,
        'change-history'
      ]"
      [routerLinkActive]="['active']"
      class="item"
      *transloco="let t"
    >
      {{
        config.tenant === tenants.FR
          ? t("view-change-logs")
          : t("change-history")
      }}
    </div>
    <div (click)="openAllTaxReturnsPage(taxReturn?.atlasId)" class="item">
      {{ 'view-all-tax-return-alias' | transloco: {taxReturnAlias} }}
    </div>
  </div>
  }
  <!--<div class="secondary-sub-menu" class="ui list">-->
  <!--<div [routerLink]="['documents']" [routerLinkActive]="['active']" class="item">Documents-->
  <!--</div>-->
  <!--<div [routerLink]="['tr package']" [routerLinkActive]="['active']" class="item">TR Package-->
  <!--</div>-->
  <!--<div [routerLink]="['notes']" [routerLinkActive]="['active']" class="item">Notes-->
  <!--</div>-->
  <!--<div [routerLink]="['comments']" [routerLinkActive]="['active']" class="item">Comments-->
  <!--</div>-->
  <!--<div [routerLink]="['missing-information']" [routerLinkActive]="['active']" class="item">Missing Information-->
  <!--</div>-->
  <!--</div>-->
  @if (taxReturn) {
  <div id="footer-menu">
    @if (allowUpdateAttachments) {
    <span>
      <div
        (click)="showAttachmentsModal()"
        [ngClass]="{ disabled: isUpdatingAttachments }"
        *transloco="let t"
      >
        {{ isUpdatingAttachments ? t("updating") : t("update") }}
        {{ "attachments" | transloco }}
        @if (isUpdatingAttachments) {
        <div class="ui active inline loader smaller"></div>
        }
      </div>
    </span>
    } @if (draftGenerateLinkFirst) {
    <span>
      <div id="package-path">
        @if (taxReturn?.docshareTempFolder) {
        <span>
          @if (useFileSystemStorage) {
          <a (click)="onClickFolderLink('temp')">{{
            "rubix-documents" | transloco
          }}</a>
          } @if (!useFileSystemStorage) {
          <a
            [href]="taxReturn?.docshareTempFolder | KExplorer"
            target="_blank"
            rel="noreferrer"
            >{{ "rubix-documents" | transloco }}</a
          >
          }
        </span>
        } @if (!taxReturn?.docshareTempFolder) {
        <span (click)="showPackagePathModal()">{{
          "rubix-documents" | transloco
        }}</span>
        } @if (taxReturn?.docshareTempFolder) {
        <div (click)="showPackagePathModal()" class="edit icon"></div>
        }
      </div>
      @if (!taxReturn?.docshareRootFolder) {
      <div class="docshare-root-folder" (click)="showDocshareRootFolderModal()">
        <span>
          {{ getFolderDisplayName() }}
        </span>
      </div>
      } @if (taxReturn?.docshareRootFolder) {
      <div>
        @if (useFileSystemStorage) {
        <a (click)="onClickFolderLink('root')">
          {{ getFolderDisplayName() }}
        </a>
        } @if (!useFileSystemStorage) {
        <a
          [href]="taxReturn?.docshareRootFolder | KExplorer"
          target="_blank"
          rel="noreferrer"
        >
          {{ getFolderDisplayName() }}
        </a>
        }
        <div
          (click)="showDocshareRootFolderModal()"
          class="edit icon"
          title="Edit {{ getFolderDisplayName() }}"
        ></div>
      </div>
      }
    </span>
    } @if (!draftGenerateLinkFirst) {
    <span>
      @if (!taxReturn?.docshareRootFolder) {
      <div class="docshare-root-folder" (click)="showDocshareRootFolderModal()">
        {{ getFolderDisplayName() }}
      </div>
      } @if (taxReturn?.docshareRootFolder) {
      <div>
        @if (useFileSystemStorage) {
        <a (click)="onClickFolderLink('temp')">
          {{ getFolderDisplayName() }}
        </a>
        } @if (!useFileSystemStorage) {
        <a
          [href]="taxReturn?.docshareRootFolder | KExplorer"
          target="_blank"
          rel="noreferrer"
        >
          {{ getFolderDisplayName() }}
        </a>
        }
        <div
          (click)="showDocshareRootFolderModal()"
          class="edit icon"
          title="Edit {{ getFolderDisplayName() }}"
        ></div>
      </div>
      }
      <div id="package-path">
        @if (taxReturn?.docshareTempFolder) {
        <div>
          @if (useFileSystemStorage) {
          <a (click)="onClickFolderLink('root')">{{
            "rubix-draft-folder" | transloco
          }}</a>
          } @if (!useFileSystemStorage) {
          <a
            [href]="taxReturn?.docshareRootFolder | KExplorer"
            target="_blank"
            rel="noreferrer"
            >{{ "rubix-draft-folder" | transloco }}</a
          >
          }
        </div>
        } @if (!taxReturn?.docshareTempFolder) {
        <div (click)="showPackagePathModal()">
          {{ "rubix-draft-folder" | transloco }}
        </div>
        } @if (taxReturn?.docshareTempFolder) {
        <div (click)="showPackagePathModal()" class="edit icon"></div>
        }
      </div>
    </span>
    } @if (config.featureFlags.sendAtlasStatusStepUpdates) {
    <div>
      @if (!taxReturn?.atlasCirDate && showActionButtons()) {
      <div (click)="showAtlasCirModal()" class="atlas-cir-date">
        {{ "add-atlas-cir-date" | transloco }}
      </div>
      } @if (taxReturn?.atlasCirDate && showActionButtons()) {
      <div class="atlas-cir-date" (click)="showAtlasCirModal()">
        {{ "atlas-cir-date" | transloco }}
        <div class="edit icon" title="Edit Atlas CIR Date"></div>
      </div>
      }
    </div>
    } @if (userInfo.isAdmin && !isLodged() && config.tenant === tenants.AU) {
    <div
      (click)="showLodgementCodeModal()"
      id="lodgement-code"
      title="{{ taxReturn?.lodgementCode ? 'Edit lodgement code' : undefined }}"
    >
      {{ "lodgement-code" | transloco }}
      @if (taxReturn?.lodgementCode) {
      <div class="edit icon"></div>
      }
    </div>
    } @if (!userInfo.isAdmin && !isLodged() && config.tenant === tenants.AU) {
    <div
      id="no-lodgement-code"
      title="Admin required to set the lodgement code"
    >
      {{ "lodgement-code" | transloco }}
    </div>
    } @if ( taxReturn?.lodgementCode && isLodged() && config.tenant ===
    tenants.AU ) {
    <div id="lodged-code">
      {{ "lodgement-code-tax-return-lodgement-code" | transloco }}
      {{ taxReturn?.lodgementCode }}
    </div>
    } @if (config.tenant === tenants.SG) {
    <div>
      @if (dmsStats?.addToCwpFolderLink) {
      <a
        [href]="dmsStats?.addToCwpFolderLink"
        target="_blank"
        rel="noreferrer"
        >{{ "add-to-cwp-folder" | transloco }}</a
      >
      }
      <div (click)="mergeCwp()">
        {{ "merge-cwp-documents-dms-stats-cwp-files-count-0" | transloco }}
      </div>
    </div>
    }
    <div *transloco="let t">
      @if ( canGenerateDraftPackage() && !taxReturn?.generateRobotQueueItemId )
      {
      <div
        (click)="templateSelectionModalAction()"
        id="generate-draft-package"
        [ngClass]="{ disabled: isGeneratingDraftPackage }"
      >
        {{ labelGenerateDraft ? t("generate") : t("preview") }}
        {{ "draft-package" | transloco }}
        @if (isGeneratingDraftPackage) {
        <i class="circle notch icon loading"></i>
        }
      </div>
      } @if (taxReturn?.generateRobotQueueItemId) {
      <div class="generating disabled">
        {{ labelGenerateDraft ? t("generation") : t("preview-generation") }}
        {{ "in-progress" | transloco }}
        <i class="inline circle notch icon loading"></i>
      </div>
      }
    </div>
  </div>
  } @if (showActionButtons()) {
  <div class="actions">
    @for (action of taxReturn?.fullStatus?.actions(config); track action) {
    <div
      class="ui button slide tax-return-action main-action"
      [ngClass]="{
        disabled:
          refreshing ||
          taxReturnActionsComponent?.actioning ||
          (action.disabled &&
            action.disabled({
              taxReturn: taxReturn,
              warningCount: getWarningsCount(),
              config: config,
              userInfo: userInfo
            })),
        loading: taxReturnActionsComponent?.actioning === action.id
      }"
      [hidden]="
        action.hasUserRestriction && action.hasUserRestriction(config, userInfo)
      "
      [class]="action.id"
      [title]="action.title || action.name || ''"
      (click)="doAction(action)"
    >
      {{ action.name }}
    </div>
    }
    <app-tax-return-actions
      (refresh)="refresh($event)"
      (shouldNavigateToTaxReturn)="refresh($event)"
      (shouldNavigateFromTaxReturn)="navigateAway($event)"
    >
    </app-tax-return-actions>
  </div>
  }
  <div
    #docshareRootFolderModal
    id="docshare-root-folder-modal"
    class="ui tiny modal"
  >
    <div class="icon modal-close close"></div>
    <h1>
      {{ getFolderDisplayName() }}
    </h1>
    @if (!taxReturn?.docshareRootFolder) {
    <div class="content">
      {{ "loading-package-location" | transloco }} &nbsp;
      <div class="ui active inline loader small"></div>
    </div>
    } @if (taxReturn?.docshareRootFolder) {
    <div class="content">
      <p>
        {{
          "click-the-link-below-to-view-the-get-folder-display-name" | transloco
        }}
        {{ getFolderDisplayName() }}
      </p>
      <a (click)="onClickFolderLink(taxReturn?.docshareRootFolder)">{{
        taxReturn?.docshareRootFolder
      }}</a>
    </div>
    }
    <div class="actions">
      @if (taxReturn?.docshareRootFolder) {
      <button
        class="ui primary background button"
        (click)="reloadDocshareFolders()"
        [ngClass]="{ disabled: loadingDocshareFolders }"
      >
        {{ "refresh" | transloco }}
      </button>
      }
      <button class="ui primary approve background button">
        {{ "close" | transloco }}
      </button>
    </div>
  </div>
  <div #cwpModal id="cwp-modal" class="ui tiny modal">
    <div class="icon modal-close close"></div>
    @if (processingCwp) {
    <div class="content">
      {{ "processing-cwp-documents" | transloco }} &nbsp;
      <div class="ui active inline loader small"></div>
    </div>
    } @if (cwpMergedSuccess && !processingCwp) {
    <div class="content">
      <div class="icon green-success"></div>
      <h2>{{ "process-cwp-documents-successful" | transloco }}</h2>
    </div>
    } @if (!cwpMergedSuccess && !processingCwp) {
    <div class="content">
      <p></p>
      <div class="icon red-error"></div>
      <h2>{{ "error-with-processing-cwp-documents" | transloco }}</h2>
    </div>
    }
    <div class="actions">
      <button class="ui primary approve background button">
        {{ "close" | transloco }}
      </button>
    </div>
  </div>
  <div #attachmentsModal id="attachments-modal" class="ui tiny modal">
    <div class="icon modal-close close"></div>
    <h1>{{ "update-attachments" | transloco }}</h1>
    <form (ngSubmit)="updateAttachments()">
      <div class="content">
        {{ 'are-you-sure-you-want-to-update-attachments-for-this-tax-return-alias' | transloco: {taxReturnAlias} }}
      </div>
      <div class="actions">
        <span class="go-back cancel">{{ "cancel" | transloco }}</span>
        <button
          class="ui primary background approve button"
          [disabled]="isUpdatingAttachments"
        >
          {{ "update" | transloco }}
        </button>
      </div>
    </form>
  </div>
  <div #atlasCirModal id="atlas-cir-modal" class="ui tiny modal">
    <div class="icon modal-close close"></div>
    <h1 *transloco="let t">
      {{ taxReturn?.atlasCirDate ? t("edit") : t("add") }}
      {{ "atlas-cir-date" | transloco }}
    </h1>
    <form (ngSubmit)="saveAtlasCirDate()">
      <div class="content">
        <label *transloco="let t"
          >{{ "atlas" | transloco }}
          {{ cirFullName ? t("complete-information-received") : t("cir") }}
          {{ "date" | transloco }}</label
        >
        <input
          type="text"
          name="name"
          [placeholder]="atlasCirDateFormat"
          [formControl]="atlasCirDate"
        />
        @if (!atlasCirDate.valid) {
        <div class="validation-text">
          {{ "please-enter-a-valid-date" | transloco }}
        </div>
        }
      </div>
      <div class="actions">
        <span class="go-back cancel">{{ "cancel" | transloco }}</span>
        <button
          class="ui primary background approve button"
          [disabled]="!(atlasCirDate.valid && atlasCirDate.dirty)"
        >
          {{ "save" | transloco }}
        </button>
      </div>
    </form>
  </div>
  <div #packagePathModal id="package-path-modal" class="ui modal">
    <div class="icon modal-close close"></div>
    <h1>{{ "rubix-documents" | transloco }}</h1>
    @if (!taxReturn?.docshareTempFolder) {
    <div class="content">
      {{ "loading-package-location" | transloco }} &nbsp;
      <div class="ui active inline loader"></div>
    </div>
    } @if (taxReturn?.docshareTempFolder) {
    <div class="content">
      <p>
        {{
          "click-the-link-below-to-view-generated-tax-package-documents"
            | transloco
        }}
      </p>
      <a (click)="onClickFolderLink(taxReturn?.docshareTempFolder)">{{
        taxReturn?.docshareTempFolder
      }}</a>
    </div>
    }
    <div class="actions">
      @if (taxReturn?.docshareTempFolder) {
      <button
        class="ui primary background button"
        (click)="reloadDocshareFolders()"
        [ngClass]="{ disabled: loadingDocshareFolders }"
      >
        {{ "refresh" | transloco }}
      </button>
      }
      <button class="ui primary approve background button">
        {{ "close" | transloco }}
      </button>
    </div>
  </div>
  <div #lodgementCodeModal id="lodgement-code-modal" class="ui tiny modal">
    <div class="icon modal-close close"></div>
    <h1 *transloco="let t">
      {{ taxReturn?.lodgementCode ? t("edit") : t("add") }}
      {{ taxReturnAlias }} {{ "lodgement-code" | transloco }}
    </h1>
    <form (ngSubmit)="saveLodgementCode()">
      <div class="content">
        <label>{{ "lodgement-code" | transloco }}</label>
        <input
          type="text"
          name="name"
          placeholder="Enter lodgement code"
          [(ngModel)]="lodgementCode"
        />
      </div>
      <div class="actions">
        <span class="go-back cancel">{{ "cancel" | transloco }}</span>
        <button class="ui primary background approve button">
          {{ "save" | transloco }}
        </button>
      </div>
    </form>
  </div>
  <div #calcResultsModal id="calc-results-modal" class="ui tiny modal">
    @if (!isRunningCalcs) {
    <div class="modal-close close icon"></div>
    } @if (isRunningCalcs) {
    <h1>{{ "taxReturns.processing-calculation" | transloco }}</h1>
    } @if (!isRunningCalcs) {
    <h1>{{ "taxReturns.finished-calculation" | transloco }}</h1>
    }
    <div class="content">
      @for (line of calcResultsSummary; track line) {
      <p>
        {{ line }}
      </p>
      } @if (!showCalcDebug) {
      <ol>
        @for (f of calcFailures; track f) {
        <li>{{ f }}</li>
        }
      </ol>
      } @if (showCalcDebug) {
      <span>
        <table>
          <thead>
            <tr>
              <th>{{ "taxReturns.question-id" | transloco }}</th>
              <th>{{ "taxReturns.execution-time-ns" | transloco }}</th>
              <th>{{ "taxReturns.trace-time-ns" | transloco }}</th>
              <th>{{ "taxReturns.has-failed-input" | transloco }}</th>
              <th>{{ "taxReturns.skip-trace-creation" | transloco }}</th>
            </tr>
          </thead>
          <tbody>
            @for (q of calcDebug; track q) {
            <tr>
              <td>{{ q.questionId }}</td>
              <td>{{ q.exec / 1000000 | number }}</td>
              <td>{{ q.traceTime / 1000000 | number }}</td>
              <td>{{ q.failedInput }}</td>
              <td>{{ q.skipTrace }}</td>
            </tr>
            }
          </tbody>
        </table>
      </span>
      }
    </div>
    <div class="actions">
      @if (isAdmin) {
      <div class="ui primary background button" (click)="toggleCalcDebug()">
        {{ "taxReturns.toggle-calc-debug" | transloco }}
      </div>
      } @if (!isRunningCalcs) {
      <div
        class="ui primary background button approve"
        (click)="clearCalcsResults()"
      >
        {{ "taxReturns.ok" | transloco }}
      </div>
      }
    </div>
  </div>
</div>
}
